function generateUrlParams(obj) {
    let paramsString = "";
    const entries = Object.entries(obj);
    entries.forEach(([key, value], index) => {
        if (value !== undefined) {
            index === 0
                ? (paramsString += `${key}=${value}`)
                : (paramsString += `&${key}=${value}`);
        }
    });
    return paramsString;
}

export { generateUrlParams };
//# sourceMappingURL=generateUrlParams.js.map
